import { CONFIG } from '../config.js';

/**
 * Toggleable Matrix atmosphere / performance knobs (Phase 7).
 * Mutate fields at runtime to A/B test individual effects.
 */
export class GraphicsSettings {
  /** @param {Partial<GraphicsSettings>} [overrides] */
  constructor(overrides = {}) {
    const d = CONFIG.graphics;
    /** @type {boolean} */
    this.bloom = d.bloom;
    /** @type {boolean} */
    this.fog = d.fog;
    /** @type {boolean} */
    this.scanlines = d.scanlines;
    /** @type {boolean} */
    this.glitch = d.glitch;
    /** @type {boolean} */
    this.noise = d.noise;
    /** @type {boolean} */
    this.chromaticAberration = d.chromaticAberration;
    /** @type {number} Multiplier on rain stream count (0 = no rain glyphs) */
    this.rainDensity = d.rainDensity;
    /** @type {number} Camera far plane & fog distance */
    this.renderDistance = d.renderDistance;
    /** @type {boolean} Sky rain visibility (Phase 12 UI) */
    this.rainEnabled = CONFIG.rain.enabled;
    /** @type {number} Cap for renderer pixel ratio (quality preset) */
    this.pixelRatioMax = CONFIG.renderer.pixelRatioMax;
    /** @type {'low' | 'medium' | 'high'} */
    this.qualityPreset = 'medium';
    Object.assign(this, overrides);
  }

  /** @param {Partial<GraphicsSettings>} patch */
  apply(patch) {
    Object.assign(this, patch);
  }

  /** @param {boolean} enabled */
  setPostProcessingEnabled(enabled) {
    this.scanlines = enabled;
    this.noise = enabled;
    this.chromaticAberration = enabled;
    this.glitch = enabled;
  }

  get postProcessingEnabled() {
    return (
      this.scanlines ||
      this.noise ||
      this.chromaticAberration ||
      this.glitch
    );
  }
}
